import {_axios as axios} from  "../../plugins/axios.js";
import kit from "../../plugins/kit.js"

import { Message, MessageBox  } from "element-ui";
import i18nKit from "../../plugins/I18N.js"
import Auth from "../../plugins/auth.js"

let api = kit.api;
let i18n = i18nKit.methods;
let auth = Auth.methods;


/**
 * 计算vxetable的行合并逻辑，这里只计算显示出来的行是否需要合并，并且只合并指定的行。
 * @param {*} dataTableRef 
 * @returns 
 */
const mergeRow = function(dataTableRef){
    
    //要合并的行的key
    const fields = ['code', 'detailQty', 'remark1', 'orderStatus', 'status','created', 'shopDayToShip', 'shopName', 'expPageStatus', 'amtOrder', 'expCompany'];

    //查找要合并行所在的rowIndex。
    const findAllOccurrences = function(arr, item){
        var subArr = [];
        for(var i = 0; i < arr.length; i++){
            if(arr[i] === item){
                subArr.push(i);
            }
        }
        return subArr;
    }

    var data = dataTableRef.getTableData();
    //完整的全量表体数据、处理条件之后的全量表体数据、当前渲染中的表体数据、当前渲染中的表尾数据分别对应fullData, visibleData, tableData, footerData
    var visibleData = data.tableData;

    //页面刚刚初始化完成，无法获取到visiableData,所有默认去总数据里面取10条
    if (visibleData.length <= 1) {
        visibleData = data.visibleData.slice(0, 10);
    }
    //开始计算合并的位置
    var offset = dataTableRef.getVTRowIndex(visibleData[0]);

    var mergeCellResult = [];
    // if (fields.length == 0) {
    //     this.mergeCells = mergeCellResult;
    //     return;
    // }
    var allColumns = dataTableRef.getColumns();
    var columnNames = allColumns.map(x => x.property);
    for (var i = 0; i < fields.length; i++) {
        var property = fields[i];
        var rowIndex = 0;
        var colIndexes = findAllOccurrences(columnNames, property);
        if (colIndexes.length <= 0) {
            continue;
        }
        while (rowIndex < visibleData.length) {
            var row = visibleData[rowIndex];
            const cellValue = row[property];
            var rowspan = 1;
            var startIndex = rowIndex;
            if (cellValue != undefined && cellValue != null) {
                let nextRow = visibleData[rowIndex + 1];
                // while (nextRow && nextRow[property] == row[property]) {
                while (nextRow && nextRow.stockId === row.stockId) {
                    rowIndex++;
                    nextRow = visibleData[rowIndex + 1];
                    rowspan++;
                }
            }
            if (rowspan > 1) {
                for (var p = 0; p < colIndexes.length; p++) {
                    mergeCellResult.push({row: offset + startIndex, col: colIndexes[p], rowspan: rowspan});
                }
                rowspan = 1;
            }
            rowIndex++;
        }
    }
    return mergeCellResult;
}

/**
 * //货单备注/报单备注
 * @param {*} type 类型
 * @param {*} selectes 选中的数据
 * @param {*} success 执行成功后的回调函数
 * @returns 
 */
const updateRemark = function(type, selectes, success){
    //货单备注/报单备注
    if(!auth.hasPermission("stock:detailEdit")){
        Message(i18n.msg('无操作权限'));
        return;
    }

    if(selectes.length == 0){
        Message(i18n.msg('请选中一条数据进行操作'));
        return;
    }

    let label = "";
    if(type == 1){
        label = '请输入报单备注';
    }else{
        label = '请输入货单备注';
    }
    let ids = [...new Set(selectes.map(e=> e.stockId))].join(',');

    MessageBox.prompt(label, i18n.msg('提示'), {
        confirmButtonText: i18n.msg('确定'),
        cancelButtonText: i18n.msg('取消'),
    }).then(({ value }) => {
        if(value && value.length > 100){
            Message(i18n.msg('备注超长，请控制在100字内'));
            return;
        }
        axios.post(
            api.stock.updateRemarks+"?t="+type, 
            {ids:ids,remark:value?value:''}
        ).then((result) => {
            if(result.status){
                if(success){
                    success();
                }
                Message(result.msg);
            }else{
                Message(result.msg?result.msg:i18n.msg('更新失败'));
            }
        });
    }).catch(() => {
        Message({
            type: 'info',
            message: '取消输入'
        });
    });
}
const updateQty = function(row,refreshList){
    let stockId = row.stockId;
    let detailId = row.id;
    MessageBox.prompt("更新数量", i18n.msg('提示'), {
        closeOnClickModal:false,
        confirmButtonText: i18n.msg('确定'),
        cancelButtonText: i18n.msg('取消'),
    }).then(({ value }) => {

        if(value <= 0){
            Message("数量不正确");
            return;
        }

        axios.post(api.stockDetail.updateQty
            +"?qty="+value
            +"&id="+stockId
            +"&detailId="+detailId
        ).then((result) => {
            // if(result.status){
            //     }
            if(refreshList){
                refreshList();
            }
            Message(result.msg);
        });
    }).catch(() => {
        Message({
            type: 'info',
            message: '取消输入'
        });
    });
}
const updateCost = function(row,refreshList){
    let stockId = row.stockId;
    let detailId = row.id;
    MessageBox.prompt("更新成本", i18n.msg('提示'), {
        closeOnClickModal:false,
        confirmButtonText: i18n.msg('确定'),
        cancelButtonText: i18n.msg('取消'),
    }).then(({ value }) => {

        if(value <= 0){
            Message("数量不正确");
            return;
        }

        axios.post(api.stockDetail.updateDetailCosts
            +"?detailIds="+detailId
            +"&cost="+(((value*100).toFixed(0) || 0))
        ).then((result) => {
            // if(result.status){
            //     }
            if(refreshList){
                refreshList();
            }
            Message(result.msg);
        });
    }).catch(() => {
        Message({
            type: 'info',
            message: '取消输入'
        });
    });
}
/**
 * 
 * @param {} detail stockDetail
 * @param {*} finish 删除成功后的回调
 */
const deleteDetail = function(detail, finish){

    const requestDelete = function(detail){
        let detailId = detail.id;
        axios.post(
            api.stockDetail.deleteDetail+'?id='+detailId
        ).then((result)=>{
            if(result.status){
                if(finish) finish();
                Message(result.msg || i18n.msg("删除成功"));
            }else{
                Message(result.msg || i18n.msg("删除失败"));
            }
        }); 
    }

    if(!auth.hasPermission("stock:detailEdit")){
        Message(i18n.msg('无操作权限'));
        return;
    }

    let status = detail.status;
    if(status >= 13 && status <= 23){
        requestDelete(detail);
    }else{
        if(auth.hasPermission("stock:detailAddDelete")){
            requestDelete(detail);
        }else{
            Message(i18n.msg('该订单不能删除'));
        }
    }

}

/**
 * 批量删除快递单号
 * @param {*} detailIds 
 * @param {*} refreshList 
 * @returns 
 */
const deleteInnerCode = function(detailIds, refreshList){
    if(detailIds.length == 0){
        Message(i18n.msg('请选中一条数据进行操作'));
        return;
    }
    if(!auth.hasPermission("stock:detailEdit")){
        Message(i18n.msg('无操作权限'));
        return;
    }
    // console.log(detailIds);
    MessageBox.confirm(i18n.msg('确定要清除快递单号和货架号吗？'), i18n.msg('提示'), {
        confirmButtonText: i18n.msg('确定'),
        cancelButtonText: i18n.msg('取消'),
        type: 'warning'
    }).then(() => {
        axios.post(
            api.stockDetail.deleteInnerCodes,
            detailIds
        ).then((result) => {
            if(result.status){
                if(refreshList){
                    refreshList();
                }
                Message(result.msg || i18n.msg("清除成功"));
            }else{
                Message(result.msg || i18n.msg("清除失败"));
            }
        });
    }).catch((err) => {
        // console.log(err);
        Message({
            type: 'info',
            message: '取消'
        });
    });
}

/**
 * 保存采购单号
 * @param {*} stockId 
 * @param {*} stockDetail 
 * @param {*} refreshList 
 * @returns 
 */
const savePurchaseCode = function(stockId, stockDetail, refreshList){
    let user = JSON.parse(localStorage.getItem("user"));

    if(user.deptPath.indexOf('/1/6262/2') > -1){
        //圣捷下面的客户只需要有会员就可以
        if(!user.vip || user.vip == 0){
            Message(i18n('没有权限或非超级会员，不能进行快捷采购！'));
            return;
        }
    }else{
        if(!auth.hasPermission("stock:detailPurchase")){
            Message(i18n.msg('没有权限或非超级会员，不能进行快捷采购！'));
            return;
        }
    }

    // if(!auth.hasPermission("stock:detailPurchase")){
    //     Message(i18n.msg('没有权限或非超级会员，不能进行快捷采购！'));
    //     return;
    // }

    if(!stockDetail.purchaseCode){
        Message(i18n.msg('采购单号不存在'));
        return;
    }
    if(!stockDetail.purchasePlatform){
        Message(i18n.msg('请选择采购平台'));
        return;
    }

    let cost = 0;
    let resCost = stockDetail.cost;
    if(resCost){
        cost = (resCost*100).toFixed(0);
    }

    MessageBox.confirm(i18n.msg('保存采购单号？'), i18n.msg('提示'), 
    {
        confirmButtonText: i18n.msg('确定'),
        cancelButtonText: i18n.msg('取消'),
    }).then(() => {
        axios.post(api.stockDetail.updateDetailPurchaseCode
            +"?code="+stockDetail.purchaseCode
            +"&type="+stockDetail.purchasePlatform
            +"&created="+stockDetail.purchaseTime
            +"&cost="+cost
            +"&id="+stockId
            +"&detailId="+stockDetail.id
        ).then((result) => {
            if(result.status && refreshList){
                refreshList();
            }
            Message(result.msg);
        });
    }).catch(() => {
        if(refreshList){
            refreshList();
        }
        Message({
            type: 'info',
            message: i18n.msg('取消'),
        });
    });
}

/**
 * 批量撤销已采购单号
 * @param {*} detailIds 
 * @param {*} refreshList 
 */
const rebackPurchaseCode = function(detailIds, reefreshList){
    if(detailIds.length == 0){
        Message(i18n.msg('请选中一条数据进行操作'));
        return;
    }
    MessageBox.confirm(i18n.msg('撤销已采购单号？'), i18n.msg('提示'), {
        confirmButtonText: i18n.msg('确定'),
        cancelButtonText: i18n.msg('取消'),
    }).then(() => {
        axios.post(api.stockDetail.rebackDetailPurchaseCodes,
            detailIds
        ).then((result) => {
            if(result.status){
                if(reefreshList){
                    reefreshList()
                }
                Message(result.msg);
            }else{
                Message(i18n.msg('请先删除快递单号'));
            }
        });
    }).catch(() => {
        if(reefreshList){
            reefreshList()
        }
        Message({
            type: 'info',
            message: i18n.msg('取消'),
        });
    });
}

/**
 * 拼接采购链接，找不到合适的去后台查找
 * 点击采购时，如果找不到采购链接；那就再使用SKU或货号来尝试能否拼成采购链接，跳转到商品页面；SKU优先于货号；只有在SKU不符合时，再以货号拼接，
 * 
 * 拼多多截取P=后面的数字作为ID，拼接到指定网址跳转到拼多多采购网页；
 * P=
 * 
 * 淘宝截取TB=后面的数字作为ID，拼接到指定网址跳转到淘宝采购网页；
 * TB=
 * 
 * 阿里巴巴截取1688=或1688-后面的数字作为ID，拼接到指定网址跳转到阿里巴巴采购网页；
 * 1688=
 * 1688-
 * 
 * 如遇到TB=698650315751 TB=669661816399这种有多个ID的SKU货号时，及中间以空格分开的，取第一个就行，
 * 后期如有问题，客户反馈再根据实际情况来优化调整，现在只简单的实现能成功；
 * 
 * 拼多多：
 * https://mobile.yangkeduo.com/goods1.html?goods_id=1562776868
 * 拼多多采购订单SKU或货号的填写样式
 * P=1562776868
 * P=5515250016
 * P=234713593369
 * P：323785393933
 * P-280660256558
 * p-276646971728
 * 
 * 淘宝
 * https://item.taobao.com/item.htm?id=722269009761
 * 淘宝采购订单SKU或货号填写的样式
 * TB=698650315751 TB=669661816399
 * TB-564063966619 TB-672153033734 TB-692970262758
 * t-630959099048
 * 
 * 阿里巴巴
 * https://detail.1688.com/offer/671464799647.html
 * 阿里巴巴采购订单SKU或货号填写的样式
 * 1688-605629237447
 * 1688-591338500991
 */
/**
 * @param {*} details StockDetail数组
 */
const concatPurchaseLink = (details) => {

    let links = new Set();
    details.forEach(d => {
        let sku = d.sku;
        let variationSku = d.variationSku;

        let link = matchGoodId(sku);
        if(!link){
            link = matchGoodId(variationSku);
        }

        if(link){
            links.add(link);
        }
    });

    return [...links];
}

/**
 * 
 * @param {构建采购链接} sku 
 * @returns 
 */
const matchGoodId = (sku) => {

    if(!sku){
        return null;
    }

    //如果是以http https开头的直接放回
    if(sku.startsWith("https://") || sku.startsWith("http://")){
        return sku;
    }

    // x

    //匹配是否存在分割符号：
    let regexp = /[\=\:\：\-\#]{1}/;
    if(!regexp.test(sku)){
        return null;
    }

    //将分割符两边的空格替换掉
    sku = sku.replace(/\s*[\=\-\：\:\#]\s*/g, "=");

    //判断是否存在多个sku，如果存在多个取第一个
    let skus = sku.split(/\s+/);
    if(skus && skus.length == 0){
        return null;
    }

    //按分割符号分割
    let splitReg = /[\=\:\：\-\#]/;
    let kv = skus[0].split(splitReg);
    if(kv == null || kv.length < 1){
        return false;
    }

    let key = kv[0].toLowerCase();
    let goodId = kv[1];
    if(key == 'p' || key == 'pdd'){
        return "https://mobile.yangkeduo.com/goods1.html?goods_id="+goodId;
    }else if(key == "t" || key =="tb" ){
        return "https://item.taobao.com/item.htm?id="+goodId;
    }else if(key == "1688"){
        return "https://detail.1688.com/offer/"+goodId+".html"
    }
    return null;

}

export default {
    mergeRow: mergeRow,
    updateRemark: updateRemark,
    deleteDetail: deleteDetail,
    deleteInnerCode: deleteInnerCode,
    rebackPurchaseCode: rebackPurchaseCode,
    concatPurchaseLink: concatPurchaseLink,
    updateQty:updateQty,
    updateCost:updateCost,
} 